import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { TolqConfig } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = TolqConfig;

export const useConfig = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query config {
      config {
        kvk
        iban
        vat
        bic
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['config'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
